import { NavBar as Bar } from "nq-component";

function NavBar() {
  return <Bar className="shadow-sm" logo="/sod.jpeg" />;
}

export default NavBar;
